import { useNavigate } from 'react-router-dom';

const WHATSAPP_URL = 'https://wa.me/5511913278081?text=Ol%C3%A1%2C%20preciso%20de%20atendimento%20jur%C3%ADdico%20urgente.';

export default function Hero() {
  const navigate = useNavigate();

  return (
    <section
      id="inicio"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dramatic%20dark%20elegant%20courtroom%20interior%20with%20atmospheric%20golden%20lighting%2C%20wooden%20furniture%20and%20polished%20marble%20floors%2C%20sophisticated%20legal%20environment%2C%20deep%20shadows%20and%20golden%20highlights%2C%20premium%20minimalist%20law%20firm%20aesthetic%2C%20high%20contrast%20moody%20photography%2C%20justice%20symbolism%2C%20dark%20navy%20blue%20deep%20tones%20with%20warm%20gold%20accents%2C%20cinematic%20quality%2C%20refined%20classical%20architecture&width=1920&height=1080&seq=hero-bg-mt-1&orientation=landscape"
          alt="Moreira & Tofoli – Defesa Criminal"
          className="w-full h-full object-cover object-top"
        />
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A1829]/95 via-[#0A1829]/80 to-[#0A1829]/60"></div>
      </div>

      {/* Decorative gold line */}
      <div className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-40 bg-gradient-to-b from-transparent via-[#B39B62] to-transparent hidden lg:block"></div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-12 pt-24 pb-16">
        <div className="max-w-3xl">
          {/* H1 */}
          <h1 className="font-serif text-5xl lg:text-7xl text-white font-light leading-[1.1] tracking-tight mb-6">
            Atuação jurídica
            <span className="block italic text-[#E9D59C]">estratégica</span>
            para decisões que exigem segurança
          </h1>

          {/* Subtitle */}
          <p className="font-sans text-white/70 text-lg lg:text-xl font-light leading-relaxed mb-10 max-w-xl">
            Atuação especializada em Direito Penal, Penal Empresarial e Direito Civil, com foco em soluções eficientes para pessoas e empresas.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-3 bg-[#B39B62] hover:bg-[#E9D59C] text-[#0A1829] font-sans font-semibold text-base px-8 py-4 rounded-md transition-all duration-300 cursor-pointer whitespace-nowrap group"
            >
              <i className="ri-whatsapp-line text-xl group-hover:scale-110 transition-transform"></i>
              Falar com um advogado
            </a>
            <a
              href="/atuacao"
              onClick={(e) => { e.preventDefault(); navigate('/atuacao'); }}
              className="inline-flex items-center justify-center gap-2 border border-white/30 hover:border-[#B39B62] text-white hover:text-[#B39B62] font-sans font-medium text-base px-8 py-4 rounded-md transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Áreas de atuação
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          {/* Bottom badges */}
          <div className="flex flex-wrap gap-6 mt-14">
            {['Atendimento 24h', 'Direito Penal e Civil', 'Atendimento Imediato'].map((item) => (
              <div key={item} className="flex items-center gap-2 text-white/50 text-sm font-sans">
                <span className="w-1 h-1 rounded-full bg-[#B39B62]"></span>
                {item}
              </div>
            ))}
          </div>

          {/* Scroll indicator – mobile only (below badges) */}
          <div className="flex lg:hidden flex-col items-center gap-2 mt-10 animate-bounce">
            <span className="text-white/30 text-xs font-sans tracking-widest uppercase">Scroll</span>
            <i className="ri-arrow-down-line text-[#B39B62]"></i>
          </div>
        </div>
      </div>

      {/* Scroll indicator – desktop only (absolute bottom) */}
      <div className="hidden lg:flex absolute bottom-8 left-1/2 -translate-x-1/2 flex-col items-center gap-2 animate-bounce">
        <span className="text-white/30 text-xs font-sans tracking-widest uppercase">Scroll</span>
        <i className="ri-arrow-down-line text-[#B39B62]"></i>
      </div>
    </section>
  );
}
